import markImage from '@assets/images/hypernova-mark.png';

/**
 * Logo de marca del portal, FIJO en todas las pantallas.
 *
 * Antes el sidebar usaba `<Logo src={companyLogo} />`, es decir el
 * `profileImage` de la empresa traido de Aludra. Eso tenia dos problemas: el
 * logo cambiaba al navegar (la query resuelve en momentos distintos, y mientras
 * no hay dato cae al asset por defecto), y el que estaba guardado en Aludra era
 * una version vieja con el texto en otro color.
 *
 * Aca la marca sale del asset oficial recortado (`hypernova-mark.png`, el "H"
 * con su degradado teal→violeta) y el logotipo se escribe como texto, para
 * poder ponerlo en BLANCO sobre el sidebar oscuro — el PNG completo trae el
 * texto en azul marino y sobre fondo oscuro no se leia.
 */
export function BrandLogo({
  className = '',
  markSize = 34,
  showWordmark = true,
  wordmarkClassName = 'text-[15px]',
  imgTestId,
}: {
  className?: string;
  /** Alto de la marca en px. El ancho se deduce de su proporcion (310x404). */
  markSize?: number;
  /** En el sidebar colapsado se muestra solo la marca. */
  showWordmark?: boolean;
  /**
   * Tamaño del logotipo. El hero del login tiene mucho mas aire que el sidebar
   * y ahi la marca va bastante mas grande.
   */
  wordmarkClassName?: string;
  /**
   * `data-testid` de la imagen. El login lo necesita para conservar el nombre
   * que ya usaba la automatizacion de QA en esa pantalla.
   */
  imgTestId?: string;
}) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="logo-container">
      <img
        src={markImage}
        alt="HyperNova Labs"
        style={{ height: markSize, width: 'auto' }}
        className="shrink-0 object-contain"
        data-testid={imgTestId ?? 'logo-image'}
      />
      {showWordmark && (
        <span className="flex flex-col justify-center leading-[1.02]">
          <span className={`${wordmarkClassName} font-extrabold tracking-[-0.02em] text-white`}>Hyper</span>
          <span className={`${wordmarkClassName} font-extrabold tracking-[-0.02em] text-white`}>Nova</span>
          <span className={`${wordmarkClassName} font-extrabold tracking-[-0.02em] text-teal-400`}>Labs</span>
        </span>
      )}
    </div>
  );
}
